import { render } from "./cardList.vue?vue&type=template&id=27590ee1&scoped=true"
const script = {}

import "./cardList.vue?vue&type=style&index=0&id=27590ee1&lang=less&scoped=true"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27590ee1"]])

export default __exports__